import { Formik, FormikProps, FormikHelpers } from "formik";
import { ReactNode } from "react";
import styles from "./CommonForm.module.scss";

interface CommonFormProps<T> {
  initialValues: T;
  validationSchema?: any;
  onSubmit: (values: T, helpers: FormikHelpers<T>) => void | Promise<void>;
  children: (props: FormikProps<T>) => ReactNode;
  className?: string;
}

export const CommonForm = <T extends object>({
  initialValues,
  validationSchema,
  onSubmit,
  children,
  className,
}: CommonFormProps<T>) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize={false}
      onSubmit={onSubmit}
    >
      {(formikProps) => (
        <form
          onSubmit={formikProps.handleSubmit}
          className={`${styles.form} ${className || ""}`}
        >
          {children(formikProps)}
        </form>
      )}
    </Formik>
  );
};
